import React from 'react';
import { Link } from 'react-router-dom';
import { INVITE } from '@/constants/testIds';

const Footer = () => (
  <footer className="mt-32 border-t border-white/5 bg-[#0B1020]/80">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 grid md:grid-cols-5 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img
            src="/maarivil-logo.png"
            alt="Maarivil — Connect, Create, Celebrate"
            data-testid="footer-logo-image"
            className="h-24 w-auto object-contain"
          />
        </div>
        <p className="text-slate-400 max-w-md leading-relaxed text-sm">
          The AI-powered global talent universe. Where artists, casting directors, event organizers and fans
          come together in one vibrant spectrum of creative possibility.
        </p>
      </div>
      <div>
        <h4 className="font-display text-white mb-4 text-sm tracking-widest uppercase">Discover</h4>
        <ul className="space-y-2 text-slate-400 text-sm">
          <li><Link to="/artists" className="hover:text-white">Browse Talent</Link></li>
          <li><Link to="/events" className="hover:text-white">Events</Link></li>
          <li><Link to="/castings" className="hover:text-white">Castings</Link></li>
          <li><Link to="/pricing" className="hover:text-white">Premium</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-white mb-4 text-sm tracking-widest uppercase">For Artists</h4>
        <ul className="space-y-2 text-slate-400 text-sm">
          <li><Link to="/onboarding" className="hover:text-white">Create Profile</Link></li>
          <li><Link to="/register" className="hover:text-white">Join Maarivil</Link></li>
          <li><Link to="/invite" data-testid={INVITE.footerLink} className="hover:text-white">Invite &amp; Earn</Link></li>
          <li><Link to="/kyc" className="hover:text-white">Get Verified</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-white mb-4 text-sm tracking-widest uppercase">Legal</h4>
        <ul className="space-y-2 text-slate-400 text-sm">
          <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link></li>
          <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms of Service</Link></li>
          <li><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="hover:text-white">Disclaimer</Link></li>
          <li><a href="mailto:support@maarivil.com" className="hover:text-white">Contact Support</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-xs text-slate-500 tracking-wider uppercase">
      © {new Date().getFullYear()} Maarivil — Where Global Talent Meets AI
    </div>
  </footer>
);

export default Footer;
